module.exports = __webpack_public_path__ + "img/map_toilet_1.85848baf.png";